import React from "react";
import { Button } from "semantic-ui-react";
import { FORM_SCHEMA_TYPES as TYPES } from "../formSchemaTypes";
import { getZendeskTicketUrl } from "../../../../../../../../constants/endpoints";
import ZendeskIcon from "../../../../../../../../components/Icons/ZendeskIcon/ZendeskIcon";
import { values } from "lodash";

export const SRILANKA_SELECT_VALUES = {
  GENDER: "GENDER",
  COUNTRIES: "COUNTRIES",
  COUNTRIES_WITH_FLAGS: "COUNTRIES_WITH_FLAGS",
  TOURIST_PURPOSE_OF_VISIT: "TOURIST_PURPOSE_OF_VISIT",
  BUSINESS_PURPOSE_OF_VISIT: "BUSINESS_PURPOSE_OF_VISIT",
  TRANSIT_PURPOSE_OF_VISIT: "TRANSIT_PURPOSE_OF_VISIT",
  PURPOSES_OF_VISIT: "PURPOSES_OF_VISIT",
  TITLE: "TITLE",
  VISA_LENGTHS: "VISA_LENGTHS",
  TYPE_OF_THIRD_PARTY: "TYPE_OF_THIRD_PARTY",
  VISA_MAIN_TYPE: "VISA_MAIN_TYPE",
  VISA_SUB_TYPE: "VISA_SUB_TYPE",
  RELATIONSHIP: "RELATIONSHIP",
  PHONE_CODES: "PHONE_CODES",
  MARITAL_STATUS: "MARITAL_STATUS",
  PORT_OF_ENTRY: "PORT_OF_ENTRY",
  PLACE_OF_STAY: "PLACE_OF_STAY",
  COUNTRIES_V2: "COUNTRIES_V2",
  TRAVEL_DOCUMENT_TYPE: "TRAVEL_DOCUMENT_TYPE",
  SL_SECURITY_QUESTIONS: "SL_SECURITY_QUESTIONS",
  VISA_TYPES: "VISA_TYPES",
};

export const sriLankaSchema = {
  generalInfoSegment: {
    label: "General application information",
    type: TYPES.SEGMENT,
    initialOpen: true,
    data: {
      _id: {
        label: "ID",
      },
      applicationType: {
        label: "Application Type",
      },
      mainApplicationId: {
        label: "Main Application ID",
        dependsOn: "applicationType",
        dependantOnValues: ["Secondary"],
      },
      siteId: {
        label: "Referral Site",
      },
      cartSiteId: {
        label: "Purchased from website",
      },
      orderId: {
        label: "Order ID",
      },
      orderIdHistory: {
        label: "Order ID history",
      },
      invoiceEmail: {
        label: "Payment email",
      },
      zendeskId: {
        label: "Zendesk ID",
        type: TYPES.TEXT,
        required: false,
        renderIcon: (propValue, applicant) => (
          <Button
            onClick={() => {
              window.open(
                getZendeskTicketUrl(propValue, applicant?.zendeskInstance),
                "_blank",
                "noopener,noreferrer",
              );
            }}
            style={{ width: 36, height: 36, padding: 0, float: "right" }}
            disabled={!propValue}
          >
            <ZendeskIcon className="zendesk-icon" />
          </Button>
        ),
      },
      submissionEmail: {
        label: "Submission email",
        type: TYPES.TEXT,
      },
      submissionPassword: {
        label: "Submission password",
        type: TYPES.TEXT,
      },
      gclid: {
        label: "Google client ID",
      },
      userLanguage: {
        label: "User form language",
      },
      userCountry: {
        label: "Users IP country",
      },
      salesAgent: {
        label: "Sales Agent",
      },
      salesCoupon: {
        label: "Sales Coupon",
      },
    },
  },
  applicant_information: {
    label: "Applicant information",
    type: TYPES.SEGMENT,
    data: {
      userEmail: {
        label: "Email",
        type: TYPES.EMAIL,
        required: true,
      },
      firstName: {
        label: "First Name",
        type: TYPES.TEXT,
        required: true,
      },
      lastName: {
        label: "Last Name",
        type: TYPES.TEXT,
        required: true,
      },
      nameTitle: {
        label: "Title",
        type: TYPES.SELECT,
        values: SRILANKA_SELECT_VALUES.TITLE,
        required: true,
      },
      birthDate: {
        label: "Date of Birth",
        type: TYPES.DATE,
        required: true,
      },
      birthCity: {
        label: "City of Birth",
        type: TYPES.TEXT,
        required: true,
      },
      maritalStatus: {
        label: "Marital Status",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.MARITAL_STATUS,
      },
      visaType: {
        label: "Visa Type",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.VISA_TYPES,
      },
      purposeOfVisit: {
        label: "Purpose of Visit",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.PURPOSES_OF_VISIT,
      },
      gender: {
        label: "Gender",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.GENDER,
      },
    },
  },
  documents_information: {
    label: "Documents information",
    type: TYPES.SEGMENT,
    data: {
      nationality: {
        label: "Nationality",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.COUNTRIES_V2,
      },
      residence: {
        label: "Country of Residence",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.COUNTRIES_V2,
      },
      passportType: {
        label: "Passport Type",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.TRAVEL_DOCUMENT_TYPE,
      },
      passportNumber: {
        label: "Passport Number",
        type: TYPES.TEXT,
        required: true,
      },
      passportIssueDate: {
        label: "Date of issue",
        type: TYPES.DATE,
        required: true,
      },
      passportExpiryDate: {
        label: "Expiration date",
        type: TYPES.DATE,
        required: true,
      },
      passportIssuePlace: {
        label: "Place of issue",
        type: TYPES.TEXT,
        required: true,
      },
    },
  },
  contact_information: {
    label: "Contact information",
    type: TYPES.SEGMENT,
    data: {
      phoneNumber: {
        label: "Phone Number",
        type: TYPES.TEXT,
        required: true,
      },
      whatsApp: {
        label: "WhatsApp",
        type: TYPES.TEXT,
        required: false,
      },
      facebookId: {
        label: "Facebook ID",
        type: TYPES.TEXT,
        required: false,
      },
      instagramId: {
        label: "Instagram user ID",
        type: TYPES.TEXT,
        required: false,
      },
      twitterId: {
        label: "Twitter user ID",
        type: TYPES.TEXT,
        required: false,
      },
      company_information: {
        label: "Company information",
        type: TYPES.NESTED,
        dependsOn: "visaType",
        dependantOnValues: ["Business"],
        nested: {
          companyName: {
            label: "Company Name",
            type: TYPES.TEXT,
          },
          companyEmail: {
            label: "Company Email",
            type: TYPES.EMAIL,
          },
          businessRegistrationNumber: {
            label: "Business Registration Number",
            type: TYPES.TEXT,
          },
          companyPhoneNumber: {
            label: "Company Phone Number",
            type: TYPES.TEXT,
          },
          companyAddressLineOne: {
            label: "Company Address Line 1",
            type: TYPES.TEXT,
          },
          companyAddressLineTwo: {
            label: "Company Address Line 2",
            type: TYPES.TEXT,
            required: false,
          },
          companyState: {
            label: "Enter state name",
            type: TYPES.TEXT,
          },
          companyCity: {
            label: "Enter city name",
            type: TYPES.TEXT,
          },
          companyPostalCode: {
            label: "Postal / ZIP code",
            type: TYPES.NUMBER,
          },
        },
      },
    },
  },
  trip_information: {
    label: "Trip information",
    type: TYPES.SEGMENT,
    data: {
      entryPort: {
        label: "Port of Entry",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.PORT_OF_ENTRY,
      },
      placeOfStay: {
        label: "Place of Stay",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.PLACE_OF_STAY,
      },
      arrivalDate: {
        label: "Intended date of arrival",
        type: TYPES.DATE,
        required: true,
      },
      departureDate: {
        label: "Intended date of departure",
        type: TYPES.DATE,
        required: true,
      },
      contactPhone: {
        label: "Contact phone number in Sri Lanka",
        type: TYPES.TEXT,
        required: true,
      },
      accommodationAddress: {
        label: "Address of accommodation",
        type: TYPES.TEXT,
        dependsOn: "visaType",
        dependantOnValues: ["Business"],
      },
      accommodationAddressLineOne: {
        label: "Address line in Sri Lanka 1",
        type: TYPES.TEXT,
        dependsOn: "visaType",
        dependantOnValues: ["Tourist"],
      },
      accommodationAddressLineTwo: {
        label: "Address line in Sri Lanka 2",
        type: TYPES.TEXT,
        required: false,
        dependsOn: "visaType",
        dependantOnValues: ["Tourist"],
      },
      accommodationState: {
        label: "State",
        type: TYPES.TEXT,
        dependsOn: "visaType",
        dependantOnValues: ["Tourist"],
      },
      accommodationCity: {
        label: "City",
        type: TYPES.TEXT,
        dependsOn: "visaType",
        dependantOnValues: ["Tourist"],
      },
      accommodationPostalCode: {
        label: "Postal / ZIP code",
        type: TYPES.NUMBER,
        dependsOn: "visaType",
        dependantOnValues: ["Tourist"],
      },
    },
  },
  consent_and_declaration: {
    label: "Consent and declaration",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion: {
        label: "Security Question",
        type: TYPES.SELECT,
        required: true,
        values: SRILANKA_SELECT_VALUES.SL_SECURITY_QUESTIONS,
      },
      securityAnswer: {
        label: "Security Answer",
        type: TYPES.TEXT,
        required: true,
      },
      signatureOfApplicant: {
        label: "Signature of Applicant",
        type: TYPES.TEXT,
        required: true,
      },
      consentDeclaration: {
        label: "Agree with Consent and Declaration",
        type: TYPES.CHECKBOX,
        required: true,
      },
      termsConditions: {
        label: "Agree with Terms and Conditions",
        type: TYPES.CHECKBOX,
        required: true,
      },
      parental_consent: {
        label: "Personal data confidentiality & protection (if applicable)",
        type: TYPES.NESTED,
        nested: {
          parentGuardianName: {
            label: "Parent/Guardian Name",
            type: TYPES.TEXT,
          },
          parentGuardianSignature: {
            label: "Signature of parent or guardian",
            type: TYPES.TEXT,
          },
        },
      },
    },
  },
};
